// Section header. Per user request the small tracked kicker
// ("01 · MACHINE") and the right-aligned meta are gone — the H2 alone
// carries the section. `number` / `label` / `meta` props are kept on
// the API so callers don't need editing and re-introducing the kicker
// later is a one-spot change.

import type { ReactNode } from "react";

interface Props {
  /** Kept for future re-introduction of the kicker; not rendered today. */
  number?: number;
  /** Kept for future re-introduction of the kicker; not rendered today. */
  label?: string;
  title: string;
  children: ReactNode;
  /** Was rendered in the kicker row; now intentionally dropped. Kept
   *  on the API so call sites compile without edits. */
  meta?: string;
}

export function SectionFrame({ title, children }: Props) {
  return (
    <section className="flex flex-col gap-4 py-7">
      <header className="border-b border-line pb-3">
        <h2 className="font-display text-2xl font-extrabold leading-[1.12] tracking-display text-ink sm:text-3xl">
          {title}
        </h2>
      </header>
      {children}
    </section>
  );
}
